export default "__VITE_ASSET__CvKX$SMq__"